import React from 'react'
import { Button } from 'semantic-ui-react'
import { MainArticleLayout } from '../../../layouts/MainArticleLayout'
import EnquiryService from '../../../services/EnquiryService'
import { useHistory } from 'react-router-dom'

const EnquiryCancel = () => {
  const queryParams = new URLSearchParams(location.search)
  const history = useHistory()
  const cancelEnquiry = () => {
    const id = queryParams.get('id')
    return EnquiryService.cancelEnquiry(id).then((response) => {
      if (response.result) {
        history.push('/my-account/enquiries')
      }
    })
  }
  const returnToPage = () => {
    history.push('/my-account/enquiries')
  }

  return (
    <>
      <MainArticleLayout>
        <h2>Cancel your enquiry?</h2>
        <p>
          Your enquiry will be cancelled and you&apos;ll need to start a new
          enquiry to get help from us.
        </p>
        <p>
          You&apos;ll still be able to view the cancelled enquiry and the
          information we gave you in <b>My account - Enquiries</b>.
        </p>
        <p>Do you want to proceed?</p>
        <Button className="ui is-primary button" onClick={cancelEnquiry}>
          Yes, cancel enquiry
        </Button>
        <Button className="ui is-secondary button" onClick={returnToPage}>
          No, don&apos;t cancel enquiry
        </Button>
      </MainArticleLayout>
    </>
  )
}
export default EnquiryCancel
